/**
 * @file 文档模块样式
 * @author FengGuang(fengguang01@baidu.com)
 */
import React, {useEffect, useRef} from 'react';
import {message} from 'antd';

import ReactStickyPolyfill from '../../../../components/react-sticky-polyfill/ReactStickyPolyfill';
import RightMenu from './components/right-menu/RightMenu';
import useRightMenuHooks from './components/right-menu/rightMenuHooks';

import {IDocContainerProps} from './types.d';
import useCopyBtnDom from './components/copy-btn-dom/CopyBtnDomHooks';


const DocContainer: React.FC<IDocContainerProps> = (props) => {
    const contentDomRef = useRef<HTMLDivElement>(null);
    const rightMenuHooks = useRightMenuHooks(props.text, contentDomRef);

    useEffect(() => {
        if (contentDomRef.current) {
            const idAnchor = contentDomRef.current.querySelectorAll<HTMLElement>('[id]');
            const newAnchorList: HTMLAnchorElement[] = [];
            idAnchor.forEach((item) => {
                const itemClassName = item.className || '';
                if (itemClassName.indexOf('hide-anchor') === -1) {
                    const newAnchor = document.createElement('a');
                    newAnchor.className = 'hide-anchor';
                    newAnchor.id = item.id;

                    newAnchorList.push(newAnchor);

                    item.removeAttribute('id');
                    item.parentElement?.insertBefore(newAnchor, item);
                }
            });
            return () => {
                newAnchorList.forEach((item) => {
                    item.parentElement?.removeChild(item);
                });
            };
        }
    }, [props.text]);

    useCopyBtnDom<HTMLDivElement>(
        {
            getDom: () => {
                return [
                    contentDomRef.current,
                    contentDomRef.current?.querySelectorAll<HTMLDivElement>('.highlight')
                ];
            },
            onCopy: (text) => {
                const text2 = text.length > 20 ? `${text.slice(0, 20)}...` : text;
                message.info(`${text2} 已复制到剪贴板`);
                if (text.indexOf('install paddlepaddle') > -1 || text.indexOf('docker pull') > -1) {
                    // 如果点击复制按钮，则触发一次埋点事件
                    if ((window as any)._hmt) {
                        (window as any)._hmt.push(['_trackEvent', '安装', '快速安装方案生成', '安装执行']);
                    }
                }
            }
        },
        [props.text]
    );

    return (
        <div className="paddle-install-quick-main">
            <div className="paddle-install-quick-right">
                <ReactStickyPolyfill>
                    <div className="paddle-install-quick-right-menu-wrap">
                        <RightMenu
                            {...rightMenuHooks}
                        />
                    </div>
                </ReactStickyPolyfill>
            </div>

            <div className="paddle-install-quick-center">
                <div
                    className="paddle-install-quick-content markdown-body"
                    ref={contentDomRef}
                    {...{dangerouslySetInnerHTML: {__html: props.text}}}
                >
                </div>
            </div>
        </div>
    );
};

export default DocContainer;
